import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StammdatenService, MobileTextTemplate } from '@app/services/stammdaten.service';

export interface DialogData {
  mode: 'create' | 'edit';
  template?: MobileTextTemplate;
}

@Component({
  selector: 'app-dialog-mobile-textbaustein',
  templateUrl: './dialog-mobile-textbaustein.component.html',
  styleUrls: ['./dialog-mobile-textbaustein.component.css']
})
export class DialogMobileTextbausteinComponent implements OnInit {
  templateForm: FormGroup;
  isSubmitting = false;
  loading = false;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<DialogMobileTextbausteinComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private stammdatenService: StammdatenService,
    private snackBar: MatSnackBar
  ) {
    this.templateForm = this.fb.group({
      schluesselwort: ['', Validators.required],
      text: ['', Validators.required],
      sortierung: [0, Validators.required],
      status_id: [1, Validators.required]
    });
  }

  ngOnInit(): void {
    if (this.data.mode === 'edit' && this.data.template) {
      this.populateForm(this.data.template);
    }
  }

  populateForm(template: MobileTextTemplate): void {
    this.templateForm.patchValue({
      schluesselwort: template.schluesselwort,
      text: template.text,
      sortierung: template.sortierung ?? 0,
      status_id: template.status_id ?? 1
    });
  }

  onSubmit(): void {
    if (this.templateForm.valid && !this.isSubmitting) {
      this.isSubmitting = true;
      const formData = this.templateForm.value;

      const templateData: MobileTextTemplate = {
        id: this.data.template?.id,
        schluesselwort: formData.schluesselwort,
        text: formData.text,
        sortierung: formData.sortierung,
        status_id: formData.status_id
      };

      if (this.data.mode === 'create') {
        this.stammdatenService.createMobileTextTemplate(templateData).subscribe({
          next: (response) => {
            this.snackBar.open('Textbaustein erfolgreich erstellt', 'Schließen', { duration: 3000 });
            this.dialogRef.close(response);
          },
          error: (error) => {
            console.error('Error creating text template:', error);
            this.snackBar.open('Fehler beim Erstellen des Textbausteins', 'Schließen', { duration: 3000 });
            this.isSubmitting = false;
          }
        });
      } else {
        this.stammdatenService.updateMobileTextTemplate(templateData.id!, templateData).subscribe({
          next: (response) => {
            this.snackBar.open('Textbaustein erfolgreich aktualisiert', 'Schließen', { duration: 3000 });
            this.dialogRef.close(response);
          },
          error: (error) => {
            console.error('Error updating text template:', error);
            this.snackBar.open('Fehler beim Aktualisieren des Textbausteins', 'Schließen', { duration: 3000 });
            this.isSubmitting = false;
          }
        });
      }
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
